export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const isKeyOf = <TRecord extends object>(
  record: TRecord,
  key?: string,
): key is Extract<keyof TRecord, string> =>
  key !== undefined && Object.hasOwn(record, key);

export const filterEntries = <TRecord extends object>(
  record: TRecord,
  predicate: (value: TRecord[keyof TRecord], key: string) => boolean,
): Partial<TRecord> => {
  const entries = Object.entries(record) as [string, TRecord[keyof TRecord]][];
  const keptEntries = entries.filter(([key, value]) => predicate(value, key));

  return Object.fromEntries(keptEntries) as Partial<TRecord>;
};

export const areRecordsEqual = <TValue>(
  left: Record<string, TValue>,
  right: Record<string, TValue>,
  isSameValue: (left?: TValue, right?: TValue) => boolean = Object.is,
): boolean => {
  const leftKeys = Object.keys(left);
  const rightKeys = Object.keys(right);
  const keys = new Set([...leftKeys, ...rightKeys]);

  return [...keys].every((key) => isSameValue(left[key], right[key]));
};
